module.exports = __webpack_public_path__ + "img/114.ca135d5f.jpg";